import styles from './SvgContainer1.module.css';

const SvgContainer1 = () => {
  return (
    <div className={styles.svgContainer}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="938"
        height="1263"
        viewBox="0 0 938 1263"
        fill="none"
        className={styles.outermost}
      >
        <path
          d="M29.204 -78.0792C-29.2001 -172.702 16.3464 -237.836 46.4201 -258.575L481.277 -596.451L1643.85 899.818L1209 1237.69C1181.47 1261.71 1107.1 1289.75 1029.85 1209.77C933.276 1109.81 894.33 1144.8 847.962 1154.02C801.594 1163.25 747.588 1162.64 701.532 1048.65C655.476 934.657 593.275 836.363 476.204 815.387C382.547 798.607 334.853 748.978 319.411 729.103C303.968 709.228 267.664 650.749 274.548 555.85C283.152 437.227 203.278 352.665 104.202 279.868C5.12701 207.072 17.8857 154.591 38.2828 111.94C58.68 69.2901 102.209 40.1988 29.204 -78.0792Z"
          fill="black"
        />
        <path
          d="M29.204 -78.0792C-29.2001 -172.702 16.3464 -237.836 46.4201 -258.575L481.277 -596.451L1643.85 899.818L1209 1237.69C1181.47 1261.71 1107.1 1289.75 1029.85 1209.77C933.276 1109.81 894.33 1144.8 847.962 1154.02C801.594 1163.25 747.588 1162.64 701.532 1048.65C655.476 934.657 593.275 836.363 476.204 815.387C382.547 798.607 334.853 748.978 319.411 729.103C303.968 709.228 267.664 650.749 274.548 555.85C283.152 437.227 203.278 352.665 104.202 279.868C5.12701 207.072 17.8857 154.591 38.2828 111.94C58.68 69.2901 102.209 40.1988 29.204 -78.0792Z"
          fill="url(#paint0_linear_213_12)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_213_12"
            x1="-587.841"
            y1="-590.196"
            x2="858.009"
            y2="1016.26"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ED374D" />
            <stop offset="0.505208" stop-color="#FA793F" />
            <stop offset="1" stop-color="#F7F651" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="830"
        height="1027"
        viewBox="0 0 830 1027"
        fill="none"
        className={styles.middle}
      >
        <path
          d="M119.068 -674.716C107.63 -785.321 176.971 -824.163 213.072 -829.759L751.595 -944.88L1147.71 908.091L609.185 1023.21C573.952 1032.87 494.791 1025.77 460.007 920.154C416.528 788.135 366.24 802.705 320.475 790.846C274.71 778.987 226.342 754.953 234.447 632.276C242.552 509.6 229.291 394.037 132.995 324.232C55.9575 268.389 34.5955 202.957 29.3339 178.344C24.0724 153.731 16.8146 85.2833 64.2863 2.8234C123.626 -100.251 88.4787 -211.136 30.9248 -319.776C-26.6293 -428.417 7.68449 -470.126 44.6009 -499.66C81.5173 -529.194 133.366 -536.459 119.068 -674.716Z"
          fill="black"
        />
        <path
          d="M119.068 -674.716C107.63 -785.321 176.971 -824.163 213.072 -829.759L751.595 -944.88L1147.71 908.091L609.185 1023.21C573.952 1032.87 494.791 1025.77 460.007 920.154C416.528 788.135 366.24 802.705 320.475 790.846C274.71 778.987 226.342 754.953 234.447 632.276C242.552 509.6 229.291 394.037 132.995 324.232C55.9575 268.389 34.5955 202.957 29.3339 178.344C24.0724 153.731 16.8146 85.2833 64.2863 2.8234C123.626 -100.251 88.4787 -211.136 30.9248 -319.776C-26.6293 -428.417 7.68449 -470.126 44.6009 -499.66C81.5173 -529.194 133.366 -536.459 119.068 -674.716Z"
          fill="url(#paint0_linear_213_13)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_213_13"
            x1="230.274"
            y1="-740.644"
            x2="456.18"
            y2="1444.23"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ED374D" />
            <stop offset="0.505208" stop-color="#FA793F" />
            <stop offset="1" stop-color="#F7F651" />
          </linearGradient>
        </defs>
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="724"
        height="1371"
        viewBox="0 0 724 1371"
        fill="none"
        className={styles.innermost}
      >
        <path
          d="M80.2532 -169.05C52.0321 -276.604 114.616 -325.596 149.436 -336.647L664.015 -532.783L1338.89 1237.8L1178.17 1362.45C1144.82 1377.38 1065.51 1382.47 1014.98 1283.42C951.819 1159.61 904.352 1181.7 857.312 1176.98C810.271 1172.26 473.195 1195.71 395.524 1096.57C319.7 999.795 352.648 870.268 246.808 816.014C162.136 772.611 131.017 711.216 122.053 687.697C113.088 664.179 95.4468 597.647 129.747 508.896C172.623 397.958 120.929 293.754 47.4358 195.195C-26.058 96.6358 1.47256 50.1693 33.4372 15.336C65.4019 -19.4972 115.53 -34.6065 80.2532 -169.05Z"
          fill="black"
        />
        <path
          d="M80.2532 -169.05C52.0321 -276.604 114.616 -325.596 149.436 -336.647L664.015 -532.783L1338.89 1237.8L1178.17 1362.45C1144.82 1377.38 1065.51 1382.47 1014.98 1283.42C951.819 1159.61 904.352 1181.7 857.312 1176.98C810.271 1172.26 473.195 1195.71 395.524 1096.57C319.7 999.795 352.648 870.268 246.808 816.014C162.136 772.611 131.017 711.216 122.053 687.697C113.088 664.179 95.4468 597.647 129.747 508.896C172.623 397.958 120.929 293.754 47.4358 195.195C-26.058 96.6358 1.47256 50.1693 33.4372 15.336C65.4019 -19.4972 115.53 -34.6065 80.2532 -169.05Z"
          fill="url(#paint0_linear_213_14)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_213_14"
            x1="618.841"
            y1="-515.695"
            x2="492.869"
            y2="1790.67"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#ED374D" />
            <stop offset="0.505208" stop-color="#FA793F" />
            <stop offset="1" stop-color="#F7F651" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  )
};

export default SvgContainer1;